import { Outlet } from 'react-router-dom'
import ScrollToTop from '../../hooks/ScrollToTop'
import Footer from '../Footer/Footer'
import Header from '../Header/Header'

const Layout = () => {
  ScrollToTop()
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  )
}
export default Layout
